import React from "react";

import {Outlet} from "react-router-dom";
import ErrorBoundary from "../../ErrorBoundary";

const EasasMainLayout = () => {
    return <ErrorBoundary showInfo={true}>
        <Outlet/>
    </ErrorBoundary>
}

export default EasasMainLayout;